/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SyncDirectoryGroupsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SyncDirectoryGroupsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type SyncDirectoryGroupsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SyncDirectoryGroupsSecurity$outboundSchema: z.ZodMiniType<
  SyncDirectoryGroupsSecurity$Outbound,
  SyncDirectoryGroupsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function syncDirectoryGroupsSecurityToJSON(
  syncDirectoryGroupsSecurity: SyncDirectoryGroupsSecurity,
): string {
  return JSON.stringify(
    SyncDirectoryGroupsSecurity$outboundSchema.parse(
      syncDirectoryGroupsSecurity,
    ),
  );
}

/** @internal */
export type SyncDirectoryGroupsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const SyncDirectoryGroupsRequest$outboundSchema: z.ZodMiniType<
  SyncDirectoryGroupsRequest$Outbound,
  SyncDirectoryGroupsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function syncDirectoryGroupsRequestToJSON(
  syncDirectoryGroupsRequest: SyncDirectoryGroupsRequest,
): string {
  return JSON.stringify(
    SyncDirectoryGroupsRequest$outboundSchema.parse(syncDirectoryGroupsRequest),
  );
}
